type T = (url: string) => boolean;

const f: T = (url) => {
    return /share\.applearn\.tv/.test(url);
};

export default f;
